import EditableDetailsCardWrapper from "entity-app/shared-components/editable-details-card-wrapper/editable-details-card-wrapper";
import FeatureActivityCard from "components/feature-activity-card/feature-activity-card";
import FeatureAttachments from "components/feature-attachments";
import { useContext, useMemo } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import { TFetureDetailUpdateAction } from "entity-app/models";
import DesignLinkedTopSection from "./components/design-linked-top-section";
import DesignPackageGeneralInfo from "./components/design-package-general-info";

function DesignPackageDetailsTab(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  featureId: string;
}) {
  const { featureInstanceData, actions, featureId } = props;
  const { tokenContents } = useContext(ProjectContext);
  const permissionsForActivityCard = useMemo(() => {
    return ["create_comment"];
  }, []);
  const cannotWriteAccessOfDesignPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.DesignPackageWrite,
    tokenContents?.role!
  );

  return (
    <div className="flex flex-col p-4 space-y-4">
      <DesignLinkedTopSection
        actions={actions}
        featureInstanceData={featureInstanceData}
        disabled={cannotWriteAccessOfDesignPackage}
      />
      <div className="grid grid-cols-3 gap-4 w-full h-[563px] pb-10">
        <EditableDetailsCardWrapper title="General Information">
          <DesignPackageGeneralInfo
            featureInstanceData={featureInstanceData}
            actions={actions}
            disabled={cannotWriteAccessOfDesignPackage}
          />
        </EditableDetailsCardWrapper>

        <FeatureActivityCard
          historyTabContents={<div>History</div>}
          featureId={featureId}
          featureKey="feature_instance_id"
          permissions={permissionsForActivityCard}
          showHistoryTab={false}
        />

        <EditableDetailsCardWrapper title="Attachments">
          <FeatureAttachments
            featureId={featureId}
            featureKey="feature_instance_id"
          />
        </EditableDetailsCardWrapper>
      </div>
    </div>
  );
}

export default DesignPackageDetailsTab;
